module.exports = __webpack_public_path__ + "static/img/h34.87990ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h34.jpg
// module id = 8j5u
// module chunks = 0